const ProjectCommentTypes = {

    ADD_PROJECT_COMMENT: 'ADD_PROJECT_COMMENT',
    ADD_PROJECT_COMMENT_LOADING: 'ADD_PROJECT_COMMENT_LOADING',
    ADD_PROJECT_COMMENT_SUCCESS: 'ADD_PROJECT_COMMENT_SUCCESS',
    ADD_PROJECT_COMMENT_ERROR: 'ADD_PROJECT_COMMENT_ERROR',
    ADD_PROJECT_COMMENT_RESET: 'ADD_PROJECT_COMMENT_RESET',

    // get comment
    GET_PROJECT_COMMENT: "GET_PROJECT_COMMENT",
    GET_PROJECT_COMMENT_LOADING: "GET_PROJECT_COMMENT_LOADING",
    GET_PROJECT_COMMENT_SUCCESS: "GET_PROJECT_COMMENT_SUCCESS",
    GET_PROJECT_COMMENT_RESET: "GET_PROJECT_COMMENT_RESET",
    GET_PROJECT_COMMENT_ERROR: "GET_PROJECT_COMMENT_ERROR",

    // delete comment

    DELETE_PROJECT_COMMENT: "DELETE_PROJECT_COMMENT",
    DELETE_PROJECT_COMMENT_LOADING: "DELETE_PROJECT_COMMENT_LOADING",
    DELETE_PROJECT_COMMENT_SUCCESS: "DELETE_PROJECT_COMMENT_SUCCESS",
    DELETE_PROJECT_COMMENT_ERROR: "DELETE_PROJECT_COMMENT_ERROR",
    DELETE_PROJECT_COMMENT_RESET: "DELETE_PROJECT_COMMENT_RESET",
   
    // update comment
    UPDATE_PROJECT_COMMENT: "UPDATE_PROJECT_COMMENT",
    UPDATE_PROJECT_COMMENT_LOADING: "UPDATE_PROJECT_COMMENT_LOADING",
    UPDATE_PROJECT_COMMENT_SUCCESS: "UPDATE_PROJECT_COMMENT_SUCCESS",
    UPDATE_PROJECT_COMMENT_ERROR: "UPDATE_PROJECT_COMMENT_ERROR",
    UPDATE_PROJECT_COMMENT_RESET: "UPDATE_PROJECT_COMMENT_RESET",

    // comment count
    GET_COMMENT_COUNT: "GET_COMMENT_COUNT",
    GET_COMMENT_COUNT_LOADING: "GET_COMMENT_COUNT_LOADING",
    GET_COMMENT_COUNT_SUCCESS: "GET_COMMENT_COUNT_SUCCESS",
    GET_COMMENT_COUNT_ERROR: "GET_COMMENT_COUNT_ERROR",
    GET_COMMENT_COUNT_RESET: "GET_COMMENT_COUNT_RESET",
};

export default ProjectCommentTypes;
